<template>
  <button class="btn btn-outline-gray btn-sm is-border-1" @click="exportUser">
    <i class="icon12-export-primary icon-left"></i>{{ $t('export') }}
    <b-modal v-model="exporting" :title="$t('exportingData')" @close="close" no-close-on-esc no-close-on-backdrop
             no-enforce-focus>
      <div class="alert alert-warning">
        <b-spinner small variant="primary"></b-spinner>&nbsp;
        <span>{{ $t('exportNotice') }}</span>
        <b-progress :max="totalCount">
          <b-progress-bar :value="downloadedCount"
                          :label="`${((downloadedCount / totalCount) * 100).toFixed(0)}%`"></b-progress-bar>
        </b-progress>
      </div>
    </b-modal>
  </button>
</template>

<script>
import {saveAs} from 'file-saver';
import Excel from 'exceljs';
import moment from 'moment';

export default {
  props: ['filter', 'totalCount'],
  data() {
    return {
      exporting: false,
      downloadedCount: 0
    }
  },
  methods: {
    close(evt) {
      if (this.exporting) {
        evt.preventDefault();
      } else {
        this.exporting = false;
      }
      this.downloadedCount = 0;
    },
    setupSheet: function (sheet) {
      let cols = [
        {header: 'name', key: 'name', width: 20},
        {header: 'ext', key: 'ext', width: 15},
        {header: 'email', key: 'email', width: 15},
        {header: 'phone', key: 'phone', width: 15},
        {header: 'group', key: 'group', width: 15},
        {header: 'role', key: 'role', width: 15},
        {header: 'createTime', key: 'createTime', width: 15},
        {header: 'lastOnlineTime', key: 'lastOnlineTime', width: 15},
        {header: 'active', key: 'active', width: 15},
      ];
      let row = {
        name: 'Tên',
        ext: 'Số nhánh',
        email: this.$t("email"),
        phone: this.$t("phone"),
        group: 'Nhóm',
        role: 'Vai trò',
        createTime: 'Tạo lúc',
        lastOnlineTime: 'Online lần cuối lúc',
        active: 'Trạng thái'
      };

      sheet.columns = cols;
      sheet.addRow(row);
    },
    exportUser: async function () {
      this.exporting = true;
      this.downloadedCount = 0;
      let workbook = new Excel.Workbook();
      let sheet = workbook.addWorksheet('data');
      this.setupSheet(sheet);

      let response = null;
      let params = Object.assign({}, this.filter);
      params.page = 1;
      params.pageSize = 500;
      do {
        let result = await this.$service.get('/user/', {
          params: params
        });
        params.page += 1;
        response = result.data;
        response.docs.forEach(item => {
          let row = {
            name: item.name ? item.name : '',
            ext: item.ext,
            email: item.email,
            phone: item.phone ? item.phone : '',
            group: item.group ? item.group.name : 'Mặc định',
            role: item.role,
            createTime: item.createTime ? moment(item.createTime).format('DD/MM/YYYY HH:mm:ss') : '',
            lastOnlineTime: item.lastOnlineTime ? moment(item.lastOnlineTime).format('DD/MM/YYYY HH:mm:ss') : 'Chưa online lần nào',
            active: item.active ? 'Đang hoạt động' : 'Tạm khoá'
          };

          sheet.addRow(row);
          this.downloadedCount += 1;
        });
      } while (response && response.hasNextPage);

      workbook.xlsx.writeBuffer({base64: true}).then(data => {
        this.exporting = false;
        this.downloadedCount = 0;
        saveAs(new Blob([data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}),
            'danh-sach-user.xlsx');
      });
    },

  }
}
</script>